let z_index = 100;

let resizee = document.querySelector("#resize");
let drag = document.querySelector('#drag');
dragElement(resizee, drag); 

let controlers_container = document.querySelector("#controlers_container");
let drag2 = document.querySelector('#drag2');
dragElement(controlers_container, drag2);  


function dragElement(elmnt, selector) {  
  var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0; 

    if (selector) {
      // if present, the header is where you move the DIV from:
      selector.onmousedown = dragMouseDown;
    } else {
      // otherwise, move the DIV from anywhere inside the DIV:
      elmnt.onmousedown = dragMouseDown;
    }

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    // get the mouse cursor position at startup:
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;
    z_index++;
    elmnt.style.zIndex = z_index; 
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    // set the element's new position:
    elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
    elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
  }

  function closeDragElement() {
    // stop moving when mouse button is released:
    document.onmouseup = null;
    document.onmousemove = null;
  }
}